import React from 'react';
import {
  FormikNumberInput as Input,
  UserMeasurementWeightUnitType,
} from '@front-activerse/common-components';
import { dietSettings } from '../types';
import { useFormikContext } from 'formik';
import { useTranslator } from '@front-activerse/common-components';

export const GoalWeight: React.FC = () => {
  const { t } = useTranslator();
  const { values } = useFormikContext<dietSettings>();

  const goalWeightUnit = values.goalWeightUnit;

  return (
    <>
      <h2 className="mb-xl title-large semi-bold">
        {t('app.goalSettings.goalBodyWeight.headline')}
      </h2>
      <Input
        name="goalWeightValue"
        placeholder="0"
        label=""
        text={
          goalWeightUnit === UserMeasurementWeightUnitType.kg
            ? t('goalSettings.goalBodyWeight.description', { min: 40, max: 250 })
            : t('goalSettings.goalBodyWeight.description', { min: 90, max: 550 })
        }
        unit={goalWeightUnit}
        step={goalWeightUnit === UserMeasurementWeightUnitType.kg ? '0.1' : '1'}
        translateErrMsg={false}
      />
    </>
  );
};

export default GoalWeight;
